"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MpContextProvider = void 0;
var react_1 = __importStar(require("react"));
var web_page_orchestrator_1 = require("@bookingcom/web-page-orchestrator");
var mp_context_1 = require("./mp-context");
var mp_store_1 = require("../store/mp-store");
var init_mp_shop_client_1 = require("../api/init-mp-shop-client");
var MpContextProvider = function (props) {
    var value = props.value, children = props.children;
    var country = value.country, pointOfSale = value.pointOfSale, currency = value.currency, env = value.env, language = value.language, locale = value.locale, etStateBlob = value.etStateBlob, mpShopClientFromProps = value.mpShopClient, affiliateId = value.affiliateId, platform = value.platform, _a = value.mock, mock = _a === void 0 ? false : _a, _b = value.includeCredentials, includeCredentials = _b === void 0 ? false : _b, reportError = value.reportError, trackExperiment = value.trackExperiment, trackExperimentStage = value.trackExperimentStage, trackCustomGoal = value.trackCustomGoal;
    var orchestrator = (0, web_page_orchestrator_1.getOrchestrator)();
    var values = (0, react_1.useMemo)(function () {
        var mpShopClient = mpShopClientFromProps ||
            (0, init_mp_shop_client_1.initMpShopClient)({
                env: env,
                mock: mock,
                etStateBlob: etStateBlob,
                mpShopAllowCredentials: includeCredentials,
            });
        return {
            country: country,
            pointOfSale: pointOfSale,
            currency: currency,
            env: env,
            language: language,
            locale: locale,
            affiliateId: affiliateId,
            platform: platform,
            mpShopClient: mpShopClient,
            trackExperiment: trackExperiment,
            trackCustomGoal: trackCustomGoal,
            trackExperimentStage: trackExperimentStage,
            mpStore: orchestrator &&
                new mp_store_1.MpStore(orchestrator, mpShopClient, trackExperimentStage, trackCustomGoal, reportError),
        };
    }, [
        mpShopClientFromProps,
        env,
        mock,
        etStateBlob,
        includeCredentials,
        country,
        pointOfSale,
        currency,
        language,
        locale,
        affiliateId,
        platform,
        trackExperiment,
        trackCustomGoal,
        trackExperimentStage,
        orchestrator,
        reportError,
    ]);
    return react_1.default.createElement(mp_context_1.MpContext.Provider, { value: values }, children);
};
exports.MpContextProvider = MpContextProvider;
